export const getLatestClosedDate = (feedbacks) =>
    feedbacks.reduce((accum, { closedDate }) => {
        if (accum === null) {
            return null;
        }

        if (closedDate === null) {
            return null;
        }
        if (closedDate) {
            const currentClosedDate = new Date(closedDate).getTime();
            const resultDate = accum ? new Date(accum).getTime() : 0;

            return currentClosedDate > resultDate ? closedDate : accum;
        }

        return accum;
    }, undefined);
